import { EMPTY_ARRAY } from '~/lib/constants'

const selectSelection = s => s.selection

export const selectFocus = s => s.selection.focus

export const selectIds = s => s.selection.ids || EMPTY_ARRAY

export const selectObjectIds = s => s.selection.objectIds || EMPTY_ARRAY

export const selectObjectSelectionOrigin = s => s.selection.objectSelectionOrigin

export default selectSelection
